import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginContext } from '../LoginContext';
import React from 'react';

const LoginChecker = () => {
  const navigate = useNavigate();
  const { loginInfo } = useContext(LoginContext);

  useEffect(() => {
    if (!loginInfo) {
      navigate('/login');
    }
  }, [loginInfo, navigate]);
};

export default LoginChecker;
